import type { ReactElement } from 'react'

import { signInAuthorizationCodeWithToken, updatePlatformHeader } from '../services/api/auth'
import { setPlatformForLogs } from '../services/datadog'
import { redirectToUrl } from '../utils/location'
import { BaseSignInRoute } from './BaseSignInRoute'

export const SignInPartnerRoute = (): ReactElement => {
  const getPlatform = (searchParams: string): string => {
    const urlParams = new URLSearchParams(searchParams)
    const redirectTo = urlParams.get('redirect_to')

    if (!redirectTo?.includes('?')) {
      return 'unknown_partner'
    }

    const redirectParams = redirectTo.split('?')[1]
    const redirectUrlParams = new URLSearchParams(redirectParams)
    const redirectClientId = redirectUrlParams.get('client_id')
    return redirectClientId || 'unknown_partner'
  }

  const platform = getPlatform(window.location.search)

  updatePlatformHeader(platform)
  setPlatformForLogs(platform)

  return BaseSignInRoute(async (accessToken, authenticationCode, secondaryFactor, redirectTo) => {
    const url = await signInAuthorizationCodeWithToken(
      accessToken,
      redirectTo ?? '',
      authenticationCode,
      secondaryFactor,
    )
    redirectToUrl(new URL(url.redirect_to, window.location.origin))
  }, platform)
}
